import { Link } from "react-router-dom";

export function DashboardFooter({ isDarkMode }) {
  return (
    <footer className={`mt-16 pb-8 text-center ${isDarkMode ? 'text-white/40' : 'text-black/40'}`} data-testid="dashboard-footer">
      <div className="flex flex-wrap justify-center gap-4 mb-4 text-sm">
        <Link to="/privacy" className="hover:text-[#00f2ea] transition-colors">Privacy Policy</Link>
        <span>•</span>
        <Link to="/terms" className="hover:text-[#00f2ea] transition-colors">Terms of Service</Link>
        <span>•</span>
        <Link to="/cookies" className="hover:text-[#00f2ea] transition-colors">Cookie Policy</Link>
        <span>•</span>
        <Link to="/contact" className="hover:text-[#00f2ea] transition-colors">Contact Us</Link>
        <span>•</span>
        <Link to="/subscription" className="hover:text-[#00f2ea] transition-colors">Pricing</Link>
      </div>
      <p className="text-xs">© {new Date().getFullYear()} TheForecastTracker. All rights reserved.</p>
      <p className="text-xs mt-1 opacity-60">Weather data provided by OpenWeatherMap & NOAA</p>
    </footer>
  );
}